// @flow
import * as React from 'react';
import TimePickerWithDate from 'components/TimePickerWithDate';
import Field from './Field';

const TimePickerWithDateField = ({
  name,
  label,
  description,
  date,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  date: string // YYYY-MM-DD
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <TimePickerWithDate
        id={id}
        name={name}
        date={date}
        value={value}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={updateValue}
        {...props}
      />
    )}
  />
);

export default TimePickerWithDateField;
